export default "__VITE_ASSET__EKLbRv4o__"